module.exports = __webpack_public_path__ + "img/2.4329df95.png";